// extracted by mini-css-extract-plugin
module.exports = {"simpleCard":"TabArtistTiled_simpleCard__zTKRH","simpleCardActive":"TabArtistTiled_simpleCardActive__np2s0","simpleCardHover":"TabArtistTiled_simpleCardHover__nrBZs"};